import { render, staticRenderFns } from "./stackadapt.vue?vue&type=template&id=12f4c066&scoped=true&v-once=true"
import script from "./stackadapt.vue?vue&type=script&lang=js"
export * from "./stackadapt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4c066",
  null
  
)

export default component.exports